var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products)?_c('ul',{staticClass:"cart-products-list"},_vm._l((_vm.products),function(product){return _c('CartRecommendationsListItem',{key:`${product.id}-${_vm.gender}`,attrs:{"options":_vm.itemOptions,"product":product},on:{"click":function($event){return _vm.pushItemEvent(product)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }